export const quizIntro = {
  quizTitle: "Quiz OW",
  quizSynopsis: "Hey team, this is a fun way to test your knowledge. The results from this quiz will allow us to identify areas of improvement and help you guys to do your best work!",
}